// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../../../utils/Utils.bs.js");
var React = require("react");
var Icon__Jsx3 = require("../Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("./Form__Input.bs.js");
var Form__Label = require("./Form__Label.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var ReactAriaComponents = require("react-aria-components");
var MarkupHelpers = require("components/MarkupHelpers");

function FormV5$Error(props) {
  return JsxRuntime.jsx("span", {
              children: props.children,
              className: "mt-1.5 text-base leading-4 font-medium text-tan-error-500 block"
            });
}

var $$Error = {
  make: FormV5$Error
};

function FormV5$Warning(props) {
  return JsxRuntime.jsx("span", {
              children: props.children,
              className: "mt-1.5 text-base leading-4 font-medium text-yellow-500 block"
            });
}

var Warning = {
  make: FormV5$Warning
};

function FormV5$SearchField$SearchFieldGoButton(props) {
  var onPress = props.onPress;
  return JsxRuntime.jsx(ReactAriaComponents.Button, {
              children: JsxRuntime.jsx(Icon__Jsx3.make, {
                    icon: "ArrowRight",
                    size: 9
                  }),
              className: (function (param) {
                  return "absolute right-[7px] bottom-[7px] pl-[1px] h-5 w-5 rounded-full bg-tan-blue-500 flex items-center justify-center text-white";
                }),
              onClick: (function (param) {
                  onPress();
                })
            });
}

var SearchFieldGoButton = {
  make: FormV5$SearchField$SearchFieldGoButton
};

function FormV5$SearchField$SearchFieldClearButton(props) {
  var onPress = props.onPress;
  return JsxRuntime.jsx(ReactAriaComponents.Button, {
              children: JsxRuntime.jsx(Icon__Jsx3.make, {
                    icon: "ReactSelectCancel",
                    size: 20
                  }),
              className: (function (param) {
                  return "absolute right-[7px] bottom-[7px] h-5 w-5 flex items-center justify-center text-zinc-400 hover:text-zinc-600";
                }),
              onClick: (function (param) {
                  onPress();
                })
            });
}

var SearchFieldClearButton = {
  make: FormV5$SearchField$SearchFieldClearButton
};

function toArray(str) {
  return str.trim().split(",").map(function (prim) {
                return prim.trim();
              }).filter(function (str) {
              return str !== "";
            });
}

function fromArray(arr) {
  return Utils.$$Array.joinWith(", ", arr);
}

function FormV5$SearchField(props) {
  var __onFocus = props.onFocus;
  var __onBlur = props.onBlur;
  var __onChange = props.onChange;
  var value = props.value;
  var onChange = __onChange !== undefined ? __onChange : (function (prim) {
        
      });
  var onBlur = __onBlur !== undefined ? __onBlur : (function (prim) {
        
      });
  var onFocus = __onFocus !== undefined ? __onFocus : (function (prim) {
        
      });
  var match = React.useState(function () {
        return fromArray(value);
      });
  var setTempValue = match[1];
  var tempValue = match[0];
  React.useEffect((function () {
          setTempValue(function (param) {
                return fromArray(value);
              });
        }), [value]);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Form__Input.make, {
                      labelText: props.labelText,
                      type: "search",
                      placeholderText: props.placeholderText,
                      grow: true,
                      onChange: (function (e) {
                          var newValue = e.target.value;
                          setTempValue(function (param) {
                                return newValue;
                              });
                        }),
                      onKeyDown: (function (e) {
                          if (e.key === "Enter") {
                            return onChange(toArray(tempValue));
                          }
                          
                        }),
                      onBlur: (function (e) {
                          onBlur(e);
                          onChange(toArray(tempValue));
                        }),
                      onFocus: (function (e) {
                          onFocus(e);
                        }),
                      value: tempValue
                    }),
                tempValue.trim() !== fromArray(value) ? JsxRuntime.jsx(FormV5$SearchField$SearchFieldGoButton, {
                        onPress: (function () {
                            onChange(toArray(tempValue));
                          })
                      }) : (
                    value.length !== 0 ? JsxRuntime.jsx(FormV5$SearchField$SearchFieldClearButton, {
                            onPress: (function () {
                                setTempValue(function (param) {
                                      return "";
                                    });
                                onChange([]);
                              })
                          }) : null
                  )
              ],
              className: "relative flex-grow"
            });
}

var SearchField = {
  SearchFieldGoButton: SearchFieldGoButton,
  SearchFieldClearButton: SearchFieldClearButton,
  toArray: toArray,
  fromArray: fromArray,
  make: FormV5$SearchField
};

function FormV5$FormGroup(props) {
  var children = props.children;
  var __wide = props.wide;
  var __inline = props.inline;
  var label = props.label;
  var inline = __inline !== undefined ? __inline : true;
  var wide = __wide !== undefined ? __wide : false;
  return JsxRuntime.jsx("div", {
              children: inline ? JsxRuntime.jsxs("div", {
                      children: [
                        label !== undefined ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Form__Label.make, {
                                      labelText: label
                                    }),
                                className: "col-span-12 md:col-span-4 lg:col-span-3 xl:col-span-2"
                              }) : null,
                        JsxRuntime.jsx("div", {
                              children: children,
                              className: wide ? "col-span-12 md:col-span-8 lg:col-span-9 xl:col-span-10" : "col-span-12 md:col-span-8 lg:col-span-5 xl:col-span-6"
                            })
                      ],
                      className: "grid grid-cols-12"
                    }) : JsxRuntime.jsxs("div", {
                      children: [
                        label !== undefined ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Form__Label.make, {
                                      labelText: label
                                    }),
                                className: "col-span-12"
                              }) : null,
                        JsxRuntime.jsx("div", {
                              children: children,
                              className: wide ? "col-span-12 md:col-span-8 lg:col-span-9 xl:col-span-10" : "col-span-12 md:col-span-8 lg:col-span-5 xl:col-span-6"
                            })
                      ],
                      className: "grid grid-cols-12"
                    }),
              className: "mb-6 lg:mb-4"
            });
}

var FormGroup = {
  make: FormV5$FormGroup
};

function FormV5$FormSection$SectionTitle(props) {
  return JsxRuntime.jsx("h5", {
              children: props.children,
              className: "pb-2.5 border-b border-zinc-200 mb-6 font-semibold leading-5 text-zinc-700"
            });
}

var SectionTitle = {
  make: FormV5$FormSection$SectionTitle
};

function FormV5$FormSection(props) {
  var __paddingFull = props.paddingFull;
  var tipbox = props.tipbox;
  var title = props.title;
  var paddingFull = __paddingFull !== undefined ? __paddingFull : true;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs(MarkupHelpers.ContentBox, {
                            paddingFull: paddingFull,
                            children: [
                              title !== undefined ? JsxRuntime.jsx(FormV5$FormSection$SectionTitle, {
                                      children: title
                                    }) : null,
                              props.children,
                              tipbox !== undefined ? JsxRuntime.jsx("div", {
                                      children: Caml_option.valFromOption(tipbox),
                                      className: "mt-4 lg:hidden"
                                    }) : null
                            ]
                          }),
                      className: "col-span-12 lg:col-span-9"
                    }),
                tipbox !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: Caml_option.valFromOption(tipbox),
                                    className: "absolute w-full"
                                  }),
                              className: "relative"
                            }),
                        className: "hidden lg:block col-span-3"
                      }) : null
              ],
              className: "grid grid-cols-12 gap-0 lg:gap-4"
            });
}

var FormSection = {
  SectionTitle: SectionTitle,
  make: FormV5$FormSection
};

var Checkbox;

var RadioButton;

var RadioButtonGroup;

var Switch;

var Label;

var HelpLabel;

var InputField;

var TextAreaField;

var RadioCardList;

var RadioList;

exports.Checkbox = Checkbox;
exports.RadioButton = RadioButton;
exports.RadioButtonGroup = RadioButtonGroup;
exports.Switch = Switch;
exports.$$Error = $$Error;
exports.Warning = Warning;
exports.Label = Label;
exports.HelpLabel = HelpLabel;
exports.InputField = InputField;
exports.TextAreaField = TextAreaField;
exports.SearchField = SearchField;
exports.FormGroup = FormGroup;
exports.FormSection = FormSection;
exports.RadioCardList = RadioCardList;
exports.RadioList = RadioList;
/* Utils Not a pure module */
